import { atom } from "recoil";

export const dataGridConfig = {
  renderAsync: false,
  showBorders: true,
  repaintChangesOnly: true,
  hoverStateEnabled: true,
  columnAutoWidth: false,
  showRowLines: false,
  showColumnLines: true,
  allowColumnResizing: true,
  columnMinWidth: 100,
};

export const permissionFlag = {
  permission: true,
};

export const defaultPageSize = 20;

export const SCHEDULE_LIMIT_API_CALLS = 5

export const signalRMethods = {
  info: "info",
  error: "error",
  success: "success",
  ir_success: "irReport",
  ps_success: "psReport",
  constroversy_change: "ControversyChange"
};

export const refreshFlagAtom = atom({
  key: "refreshFlag",
  default: false,
});

export const upgradeSitesResponseAtom = atom({
  key: "upgradeSitesResponse",
  default: "",
});

export const dateCellPicker = {
  DATE_OPTION: "date" as "date",
  DATE_TIME_OPTION: "datetime" as "datetime",
  DATE_TIME_FORMAT: "MMM d, yy hh:mm:ss a",
  DATE_FORMAT: "MMM d, yyyy",
};

export const alert_Dialog_Discription =
  "You are about to change the source of the file transfer. Doing so will clear your current selection. Do you wish to continue?";

export const IMANAGEFILE_TITLE = "Select files from iManage to copy to Tax Portal. A maximum of {xx} files can be copied to or from iManage at a time.";
export const IMANAGEFILE_SWAP_TITLE = "Select files from Tax Portal to copy to iManage. A maximum of {xx} files can be copied to or from iManage at a time.";

export const IMANAGECSFILE_TITLE = "Select files from iManage to copy to Corporate Sight. A maximum of {xx} files can be copied to or from iManage at a time.";
export const IMANAGECSFILE_SWAP_TITLE = "Select files from Corporate Sight to copy to iManage. A maximum of {xx} files can be copied to or from iManage at a time.";

export const TAXPORTAL_ID = "TaxPortal";
export const CORPORATESIGHT_ID = "CorporateSight";

export const FILES_LIMIT_PLACEHOLDER = "A maximum of {xx} files can be copied at a time."

export const UPGRADE_SITES_SCREENS = {
  UPGRADE_SITES: "Upgrade_Sites",
  SITES_SELECTED: "SitesSelected",
  BATCH_SITES_SELECTED: "BatchSitesSelected",
};

export enum ScheduleCustomPermissionStatusesEnum {
  NotScheduled = "NOT SCHEDULED",
  Scheduled = "SCHEDULED",
  InProgress = "IN PROGRESS",
  Cancelled = "CANCELLED",
  Verified = "VERIFIED",
  VerificationInProgress = "VERIFICATION IN PROGRESS",
}

export const CUSTOM_PERMISSION_BANNER_DATA = {
  "NOT SCHEDULED": {
    title: "Changes to Permissions Not Yet Published",
    bodyPrefix: "Your changes have been saved but are not yet published. They will be published once processing is complete. To process the changes, please",
    actionText: "schedule a process date.",
  },
  "SCHEDULED": (date?: string) => ({
    title: "Changes to Permissions are Scheduled for Processing",
    bodyPrefix:
      `Your changes to permissions are scheduled to be processed on ${date || '{DATE}'}.Once the changes have been processed, they will be published. If you do not wish to publish the changes, click here to`,
    actionText: "cancel the scheduled process.",
  }),
  "VERIFICATION IN PROGRESS": {
    title: "Action Required: Permission Verification Needed",
    bodyPrefix: "Please review the published permission changes to ensure they are accurate. Once your review is complete, click the button below to confirm that the permissions are correct.",
    actionButtonText: "Verify Changes",
  },
  "IN PROGRESS": {
    title: "Verification in Progress",
    bodyPrefix: "Published changes to permissions are currently under review. This process may take a few days. No action is required at this time. This banner will be updated once verification is complete.",
  },
  "VERIFIED": {
    title: "Verification Complete",
    bodyPrefix: "Your published permission changes have been successfully reviewed and approved. Custom permissions setup is now complete, and you may proceed. For any additional changes, please submit a ServiceNow ticket."
  },
  "CANCELLED": {
    title: "Changes to Permissions Not Yet Published",
    bodyPrefix: "Your changes have been saved but are not yet published. They will be published once processing is complete. To process the changes, please",
    actionText: "schedule a process date.",
  },
};
export const Duplicate_Folder_Error_Message = "Duplicate folders exist for the following entities: {xx}. Custom Permissions for duplicate folders will not update. Please rename the custom folders so each folder name is unique. If you need an entity added to the site please submit a ServiceNow ticket.";
export const DIALOG_MESSAGES = {
  SCHEDULE_PROCESS: {
    TITLE: "Schedule Process",
    BODY_TEXT_1: "Changes to permissions will be published once processing is complete. Use the calendar below to schedule a process date.",
    BODY_TEXT_2: "If you are not ready to schedule processing, select Save Without Scheduling.",
    SECTION_TITLE: "Schedule Process",
    BTN_SCHEDULE: "Schedule Process",
    BTN_SAVE_WITHOUT: "Save Without Scheduling",
  },
  CANCEL_PROCESS: {
    TITLE: "Cancel Process?",
    BODY_TEXT_1: "Are you sure you want to cancel this scheduled process?",
    BODY_TEXT_2: "Your changes will be saved but will not be published until a new process date is scheduled.",
    BTN_CONFIRM: "Confirm Cancelation",
    BTN_BACK: "Back",
  },
  DISCARD_CHANGES: {
    TITLE: "Discard Changes",
    BODY_TEXT: "You have unsaved changes. Do you want to discard them?",
    BTN_YES: "Yes",
  },
};

export const HQISheetName = {
  INFORMATION_REQUEST: "Information Request List",
  PROJECT_STATUS: "Project Status",
  CONTROVERSY_TRACKER: "Controversy Tracker",
  K1_TRACKER: "K-1 Tracker",
  NEW_OPPORTUNITIES_CHECKLIST: "New Opportunities Checklist",
  CASH_TAX_PAYMENTS: "Cash Tax Payments",
  DOCUMENT_METADATA: "Documents Metadata",
  DELIVERABLES: "Deliverables",  
  ISSUES_TRACKER: "Issues Tracker",
  ESTIMATES_TRACKER: "Estimates Tracker",
  NOTICE_TRACKER: "Notice Tracker",
  ENGAGEMENT_OVERVIEW: "Engagement Overview",
  DELIVERABLE_LISTING: "Deliverable listing",
}

export const DeliverableColumns = {
  STATUS: "Status",
  FUND: "Fund",
  FEDERAL_RETURN_TYPE: "Federal Return Type",
  FEDERAL_DUE_DATE: "Federal Due Date",
  FEDERAL_EXTENDED_DUE_DATE: "Federal Extended Due Date",
  ENTITY_NAME: "Entity Name",
}

export const AppName = {
  TP: "TP",
  CS: "CS",
  IS: "IS",
}

export const FEATURES = {
  TIM_PROJECTS: "TIMProjects",
  ROLLOVERS: "Rollovers",
  I_MANAGE_FILES: "IManageFiles",
  USER_ASSIGNMENT_HISTORY: "UserAssignmentHistory",
  MANAGE_CUSTOM_PERMISSIONS: "ManageCustomPermissions"
}

export const ESignatureStatuses = {
  SIGNED: '102_4',
  UNSIGNED: '104_4',
}

export const IRColumns = {
  STATUS: 'Status',
  ENTITY_NAME: 'Entity',
}
export const ESignatureColumns = {
  FILE_STATUS: 'File Status',
  ENTITY_NAME: 'Entity Name',
}

export const K1TrackerColumns = {
  FUND: 'Fund',
  ENTITY_NAME: 'Entity',
}

export const UserGroups = {
    CLIENT_USER: 'Client User',
    CS_AUDIT: 'CS - Audit Client user Group',
    CS_NON_AUDIT: 'CS - Non Audit Client User Group',
    CONTENT_ADMIN: 'Content admin',
    POWER_USER: 'Power User (Delegated)',
    CS_POWER_USER: 'CS - Power User (Delegated)',
    FUNCTIONAL_LEAD: 'Functional Lead',
    CS_FUNCTIONAL_LEAD: "CS - Functional Lead",
    PROJECT_LEAD: "Project Lead",
    CS_PROJECT_LEAD: "CS - Project Lead",
    RSM_ENGAGEMENT_TEAM: "RSM Engagement Team",
    CS_ENGAGEMENT_TEAM: "CS - Engagement Team",
    CS_ENGAGEMENT_TEAM_LIMITED: "CS - Engagement Team - Limited Access",
    RSM_MEMBER_FIRM_GROUP: 'RSM Member Firm',
    CS_CUSTOM_USER_GROUP: "CS - Custom User Group",
};

export const jobTypesWithoutLogDetails = ["(MS) Site Upgrade", "(MS) Create Site", "Usage Metrics Report", "(MS) Update Site Last Accessed", "(MS) Get Yearly OIT Efile Report By Client", "(MS) Custom Permission", "(MS) Rollover"];

export const JobTypesWithoutSelection = ["(MS) Rollover Retrival Storage Cleanup", "(MS) Rollover Archive Cleanup", "(MS) Custom Permission", "(MS) Rollover"];

export const jobTypesWithFrequencyDisabled = ["(MS) Custom Permission", "(MS) Rollover"];

export const CountryGroupFolderName = ["Non-US"]
